export default __webpack_public_path__ + "static/media/circle-plus-dark-pink.203f879e.svg";